export default __webpack_public_path__ + "static/media/sticker-promo-cl.ec00e4a6.webp";